import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const generatePDF = async (element, fileName = 'Public Card') => {
  if (!element) return;

  Alert.show('notice', 'Downloading PDF, please wait...')

  const options = {
    scale: 2,
    useCORS: true,
    allowTaint: false,
    backgroundColor: null,
    // Remove windowWidth - let html2canvas use the element's actual rendered size
  };

  const canvas = await html2canvas(element, options);

  const imgData = canvas.toDataURL("image/png");
  const pdf = new jsPDF("p", "mm", "a4");

  const imgProps = pdf.getImageProperties(imgData);

  const padding = 10;
  const pdfWidth = pdf.internal.pageSize.getWidth() - padding * 2;
  const pdfHeight = pdf.internal.pageSize.getHeight();

  const imgWidth = pdfWidth;
  const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

  let heightLeft = imgHeight;
  let position = padding;

  pdf.addImage(imgData, "PNG", padding, position, imgWidth, imgHeight);
  heightLeft -= pdfHeight;

  while (heightLeft > 0) {
    position = heightLeft - imgHeight + padding;
    pdf.addPage();
    pdf.addImage(imgData, "PNG", padding, position, imgWidth, imgHeight);
    heightLeft -= pdfHeight;
  }

  pdf.save(fileName);
};